import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { MediaColumn, IMAGE_SIZE } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { contentFilter } from '/utils/functions';
import useAnimation from '/utils/useAnimation';

const BlockTwoColMedia: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  presentOption,
  ...props
}) => {
  const columnData = blockContent?.columns?.list || [];
  const presentMode = useContext(PresentModeContext);
  const contextContent = contentFilter(
    blockContent.context,
    presentMode,
    presentOption,
  );

  const contextStep = contextContent ? 1 : 0;
  const preChartSteps = (animationEnabled ? 2 : 0) + contextStep; // 2 steps for the columns
  const columns = useAnimation(
    columnData,
    presentMode,
    animationStep,
    preChartSteps,
    setAnimationComplete,
  );

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      contextContent={contextContent}
      hideContext={animationEnabled && !animationStep}
      hideFooter={animationEnabled && !(animationStep >= preChartSteps)}
      titleCentered
      columns={columns.map(
        (column: ColumnContainerJson, columnNumber: number) => (
          <>
            {!column.hidden && column.name === 'media' && (
              <MediaColumn
                elements={column.elements}
                imageSize={IMAGE_SIZE.MEDIUM}
                presentOption={presentOption}
                hide={
                  animationEnabled &&
                  animationStep <= columnNumber + contextStep
                }
              />
            )}
          </>
        ),
      )}
    />
  );
};

BlockTwoColMedia.displayName = 'BlockTwoColMedia';
export default BlockTwoColMedia;
